var _path, _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillrule: "evenodd",
    cliprule: "evenodd",
    d: "M1.51129 2.66335C1.21408 2.36614 1.19427 1.89707 1.45195 1.5775L1.51117 1.51168C1.82892 1.19311 2.34465 1.19311 2.66309 1.51155L6.91378 5.76275L11.165 1.51155C11.4622 1.21434 11.9313 1.19452 12.2507 1.45201L12.3167 1.51143C12.6353 1.82918 12.6353 2.34491 12.3168 2.66335L8.065 6.91397L12.3167 11.1652C12.614 11.4617 12.6338 11.9307 12.3763 12.2509L12.3168 12.3171C12.1621 12.4717 11.9553 12.5557 11.7409 12.5557C11.5268 12.5557 11.3207 12.4719 11.165 12.3171L6.91378 8.06588L2.66284 12.3173C2.52977 12.4497 2.35887 12.5303 2.17821 12.5506L2.08719 12.5557C1.87279 12.5557 1.66597 12.4717 1.51129 12.3171C1.19285 11.9986 1.19285 11.4829 1.51129 11.1653L5.76188 6.91397L1.51129 2.66335Z",
    fill: "#333333"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "toastClose",
    masktype: "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 12,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    fillrule: "evenodd",
    cliprule: "evenodd",
    d: "M1.51129 2.66335C1.21408 2.36614 1.19427 1.89707 1.45195 1.5775L1.51117 1.51168C1.82892 1.19311 2.34465 1.19311 2.66309 1.51155L6.91378 5.76275L11.165 1.51155C11.4622 1.21434 11.9313 1.19452 12.2507 1.45201L12.3167 1.51143C12.6353 1.82918 12.6353 2.34491 12.3168 2.66335L8.065 6.91397L12.3167 11.1652C12.614 11.4617 12.6338 11.9307 12.3763 12.2509L12.3168 12.3171C12.1621 12.4717 11.9553 12.5557 11.7409 12.5557C11.5268 12.5557 11.3207 12.4719 11.165 12.3171L6.91378 8.06588L2.66284 12.3173C2.52977 12.4497 2.35887 12.5303 2.17821 12.5506L2.08719 12.5557C1.87279 12.5557 1.66597 12.4717 1.51129 12.3171C1.19285 11.9986 1.19285 11.4829 1.51129 11.1653L5.76188 6.91397L1.51129 2.66335Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#toastClose)"
  })));
};

export default __webpack_public_path__ + "static/media/ToastCloseIcon.bb9e50a7.svg";
export { SvgComponent as ReactComponent };